import { useEffect } from "react";

/**
 * Hook qui prévient la perte de modifications non sauvegardées :
 *   - Affiche un dialogue navigateur natif lors du beforeunload (refresh, fermeture onglet)
 *   - Renvoie une fonction `confirmLeave()` à utiliser dans les onClick de boutons de navigation
 *
 * Usage :
 *   const isDirty = form.first_name !== user.first_name;
 *   const confirmLeave = useUnsavedChanges(isDirty);
 *
 *   <Link onClick={(e) => { if (!confirmLeave()) e.preventDefault(); }} to="/somewhere">...</Link>
 */
export function useUnsavedChanges(dirty, message = "Vous avez des modifications non sauvegardées. Voulez-vous quand même quitter ?") {
  useEffect(() => {
    if (!dirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = message;
      return message;
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [dirty, message]);

  return () => {
    if (!dirty) return true;
    return window.confirm(message);
  };
}
